import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Typography } from "@repo/ui/aops-components/typography";
import styles from "./CourseTag.module.css";
interface CourseTagProps {
  children: ReactNode;
}
export function CourseTag(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className={styles.tagDot} aria-hidden={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={styles.tag}>{t1}<Typography as="span" variant="eyebrow" className={styles.tagText}>{children}</Typography></div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}